export const LABEL_MANAGEMENT_PAGE_DAID = 'label-management-page';
export const LABEL_MANAGEMENT_CREATE_BUTTON_DAID = 'label-management-create-button';
export const LABEL_MANAGEMENT_TABLE_DAID = 'label-management-table';
export const LABEL_MANAGEMENT_VALUES_CELL_DAID = 'label-management-values-cell';
export const LABEL_MANAGEMENT_EDIT_ACTION_DAID = 'label-management-edit-action';
export const LABEL_MANAGEMENT_VALUES_MODAL_DAID = 'label-management-values-modal';

// Label Panel
export const LABEL_MANAGEMENT_PANEL_DAID = 'label-management-panel';
export const LABEL_MANAGEMENT_PANEL_DISPLAY_NAME_INPUT_DAID =
	'label-management-panel-display-name-input';
export const LABEL_MANAGEMENT_PANEL_DESCRIPTION_INPUT_DAID =
	'label-management-panel-description-input';
export const LABEL_MANAGEMENT_PANEL_KEY_DISPLAY_DAID = 'label-management-panel-key-display';
export const LABEL_MANAGEMENT_PANEL_KEY_INPUT_DAID = 'label-management-panel-key-input';
export const LABEL_MANAGEMENT_PANEL_ADD_VALUE_INPUT_DAID = 'label-management-panel-add-value-input';
export const LABEL_MANAGEMENT_PANEL_ADD_VALUE_BUTTON_DAID =
	'label-management-panel-add-value-button';
export const LABEL_MANAGEMENT_PANEL_VALUES_TABLE_DAID = 'label-management-panel-values-table';
export const LABEL_MANAGEMENT_PANEL_DASHBOARD_TOGGLE_DAID =
	'label-management-panel-dashboard-toggle';
export const LABEL_MANAGEMENT_PANEL_REMOVE_VALUE_DAID = 'label-management-panel-remove-value';
